import { useEffect, useState } from "react"

import { useProposalContext } from "contexts/proposal"

import { getData } from "./data"

const useSummaryProposal = () => {
  const [data, setData] = useState([])
  const { proposalData } = useProposalContext()

  useEffect(() => {
    const infoData = getData(proposalData)
    setData(infoData)
  }, [])

  return {
    data,
    proposalData
  }
}

export default useSummaryProposal
